module.exports = __webpack_public_path__ + "fonts/NespressoLucas-XtraBdItalic.svg?v=4c3f326b4c38d960bbbe97a2aa5cd194";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-XtraBdItalic.svg
// module id = 639
// module chunks = 0